import { Direction } from "./DirectionButton";

export const resolvePosition = (direction?: Direction) => {
    switch (direction) {
        case 'up':
            return "left-0 bottom-10"
        case 'right':
            return "left-10";
        case 'down': 
        return "left-0 top-10"
        case 'left':
            return "left-[-2.5rem]"
        default:
            return {};
    }
}

export const resolveIcon = (direction?: Direction) => {
    switch (direction) {
        case 'up':
            return <div style={{transform: 'rotate(-0.25turn)'}}>{">"}</div>;
        case 'right':
            return <div>{">"}</div>;
        case 'down': 
            return <div style={{transform: 'rotate(270deg)'}}>{"<"}</div>;
        case 'left':
            return <div>{"<"}</div>;
        default:
            return '';
    }
}

export const resolveShading = (direction?: Direction) => {
    switch (direction) {
        case 'up':
            return 'shading-up shading';
        case 'right':
            return 'shading-right shading';
        case 'down': 
            return 'shading-down shading';
        case 'left':
            return 'shading-left shading';
        default:
            return '';
    }
}